import React from 'react';
import { Helmet } from 'react-helmet-async';
import { AwardIcon, UsersIcon, TargetIcon } from 'lucide-react';
export function About() {
  return <div className="w-full bg-black" data-id="element-57">
      <Helmet data-id="element-58">
        <title data-id="element-59">About Us - Western Royal Diesel</title>
        <meta name="description" content="Learn about Western Royal Diesel and our commitment to excellence in diesel performance and vehicle customization" data-id="element-60" />
      </Helmet>
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-black via-gray-900 to-black text-white py-16 md:py-24 border-b border-cyan-500/20" data-id="element-61">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-62">
          <h1 className="text-4xl md:text-5xl font-bold mb-6 bg-gradient-to-r from-cyan-400 to-blue-500 bg-clip-text text-transparent" data-id="element-63">
            About Us
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl" data-id="element-64">
            Western Royal Diesel and Wrap is Elizabeth, Colorado's trusted name
            in diesel performance, vehicle customization, and professional
            detailing services.
          </p>
        </div>
      </section>
      {/* Owner Section */}
      <section className="py-16 md:py-24 bg-gray-950" data-id="element-65">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-66">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-67">
            <div data-id="element-68">
              <h2 className="text-3xl md:text-4xl font-bold mb-6 text-white" data-id="element-69">
                Meet Shane Pebley
              </h2>
              <p className="text-gray-300 mb-4" data-id="element-70">
                Shane Pebley founded Western Royal Diesel and Wrap with a
                passion for diesel vehicles and a commitment to excellence. With
                years of experience in the automotive industry, Shane has built
                a reputation for delivering exceptional results and outstanding
                customer service.
              </p>
              <p className="text-gray-300 mb-4" data-id="element-71">
                Shane's expertise in diesel performance tuning, combined with
                his attention to detail in vehicle wrapping and tinting, has
                made Western Royal the go-to destination for diesel enthusiasts
                throughout Colorado.
              </p>
              <p className="text-gray-300" data-id="element-72">
                When you work with Western Royal, you're working directly with
                someone who genuinely cares about your vehicle and your
                satisfaction.
              </p>
            </div>
            <div className="border border-cyan-500/30 rounded-lg overflow-hidden h-96" data-id="element-73">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/qcpUSDbmYiS9xCKNwdiGqg/Screenshot_2025-10-26_at_2.43.18_PM.png" alt="Shane Pebley with custom GMC truck" className="w-full h-full object-cover" data-id="element-74" />
            </div>
          </div>
        </div>
      </section>
      {/* Values Section */}
      <section className="py-16 md:py-24 bg-black" data-id="element-75">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-76">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-white" data-id="element-77">
            Why Choose Us
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-78">
            <div className="text-center bg-gray-900 p-8 rounded-lg border border-blue-500/30" data-id="element-79">
              <div className="bg-gradient-to-br from-blue-500 to-cyan-500 text-white w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-80">
                <AwardIcon size={32} data-id="element-81" />
              </div>
              <h3 className="text-xl font-bold mb-3 text-cyan-400" data-id="element-82">
                Expert Craftsmanship
              </h3>
              <p className="text-gray-400" data-id="element-83">
                Years of experience and continuous training ensure top-quality
                work on every project.
              </p>
            </div>
            <div className="text-center bg-gray-900 p-8 rounded-lg border border-cyan-500/30" data-id="element-84">
              <div className="bg-gradient-to-br from-cyan-500 to-green-500 text-white w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-85">
                <UsersIcon size={32} data-id="element-86" />
              </div>
              <h3 className="text-xl font-bold mb-3 text-green-400" data-id="element-87">
                Customer Focused
              </h3>
              <p className="text-gray-400" data-id="element-88">
                Your satisfaction is our priority. We work closely with you to
                achieve your vision.
              </p>
            </div>
            <div className="text-center bg-gray-900 p-8 rounded-lg border border-green-500/30" data-id="element-89">
              <div className="bg-gradient-to-br from-green-500 to-blue-500 text-white w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-90">
                <TargetIcon size={32} data-id="element-91" />
              </div>
              <h3 className="text-xl font-bold mb-3 text-blue-400" data-id="element-92">
                Precision Results
              </h3>
              <p className="text-gray-400" data-id="element-93">
                Attention to detail in every aspect of our work, from
                performance tuning to finishing touches.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Specializations Section */}
      <section className="py-16 md:py-24 bg-gray-950" data-id="element-94">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-95">
          <h2 className="text-3xl md:text-4xl font-bold mb-12 text-white" data-id="element-96">
            Our Specializations
          </h2>
          <div className="space-y-8" data-id="element-97">
            <div className="border-l-4 border-blue-500 pl-6 bg-gray-900 p-6 rounded-r-lg" data-id="element-98">
              <h3 className="text-2xl font-bold mb-3 text-blue-400" data-id="element-99">
                Diesel Performance Upgrades
              </h3>
              <p className="text-gray-300" data-id="element-100">
                We specialize in maximizing the performance of diesel engines
                through custom tuning, ECU programming, exhaust upgrades, and
                turbo modifications. Whether you need more power for towing or
                want to optimize fuel efficiency, we have the expertise to
                deliver results.
              </p>
            </div>
            <div className="border-l-4 border-cyan-500 pl-6 bg-gray-900 p-6 rounded-r-lg" data-id="element-101">
              <h3 className="text-2xl font-bold mb-3 text-cyan-400" data-id="element-102">
                Professional Vehicle Wrapping
              </h3>
              <p className="text-gray-300" data-id="element-103">
                Transform your vehicle with our premium vinyl wraps. From color
                changes to custom graphics, we use only the highest quality
                materials and precise installation techniques to ensure a
                flawless finish that lasts.
              </p>
            </div>
            <div className="border-l-4 border-green-500 pl-6 bg-gray-900 p-6 rounded-r-lg" data-id="element-104">
              <h3 className="text-2xl font-bold mb-3 text-green-400" data-id="element-105">
                Window Tinting Services
              </h3>
              <p className="text-gray-300" data-id="element-106">
                Our professional window tinting services provide UV protection,
                heat reduction, and enhanced privacy while improving your
                vehicle's appearance. We use premium films and guarantee
                bubble-free, perfect installations.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>;
}